import React from 'react'
import { Document } from './components/document'
import { LearnMore } from './components/learnmore';
import { Split } from './components/split';
import { ImageView } from './components/imageview';

export class Solution extends React.Component {

    render() {
        return (
            <Split>
                <ImageView src="/images/problem.png"/>
                <Document>
                    <h2>Okay - So you have a better way to do this... right?</h2>
                    <p>Yes, we've built the first platform that makes LLM fine-tuning simple, enabling developers worldwide to create AI agents that actually learn from experience. Our technology makes it possible to build adaptive agents that get smarter with every interaction—just like training a human, which is impossible with fixed-weight models.</p>

                    <h2>Oh - But training LLMs sounds so complicated?</h2>
                    <p>While training LLMs may sound complicated, it's NOT. In fact, it's so much easier and more reliable than traditional prompting—and faster, and far less frustrating to work with.</p>
                    <p>Watch the video below and see for yourself just how easy it is.</p>
                    <LearnMore to="/docs/whylearning">Read more</LearnMore>
                </Document>
            </Split>
        );
    }
}

